import * as angular from 'angular';

"use strict";

angular.module('CalendarModule', [])

export default 'CalendarModule';